'use client';

import { useEffect, useState } from 'react';

export type ResponsiveSheetSide = 'bottom' | 'right';

/**
 * Presents compact education/actions as a bottom sheet on mobile and a
 * right-side drawer on larger screens.
 */
export function useResponsiveSheetSide(): ResponsiveSheetSide {
  const [side, setSide] = useState<ResponsiveSheetSide>('bottom');

  useEffect(() => {
    const mediaQuery = window.matchMedia('(min-width: 640px)');
    const updateSide = () => setSide(mediaQuery.matches ? 'right' : 'bottom');

    updateSide();
    mediaQuery.addEventListener('change', updateSide);
    return () => mediaQuery.removeEventListener('change', updateSide);
  }, []);

  return side;
}
